// Выпадашка выбора лонча в тулбаре: список с датами, «+ New launch» (пишущим), «Edit launch…» у активного.
import { Rocket } from 'lucide-react';
import { WriteOnly } from '@core/auth/access';
import { ToolbarDropdown, menuItem } from '../roadmap/shared/Toolbar';
import type { Launch } from './planner';

export function LaunchPicker({ list, active, onPick, onNew, onEdit }: { list: Launch[]; active: Launch | null; onPick: (id: string) => void; onNew: () => void; onEdit: (l: Launch) => void }) {
  return (
    <ToolbarDropdown label={active?.name ?? 'No launches'} icon={<Rocket className="w-4 h-4" />} title="Choose a launch" dataAttr="data-launch-picker" closeSignal={active?.id}>
      {list.map((l) => (
        <button key={l.id} type="button" role="menuitemradio" aria-checked={l.id === active?.id} data-launch={l.id}
          className={`${menuItem} ${l.id === active?.id ? 'font-semibold' : ''}`}
          onClick={() => onPick(l.id)}>
          {l.name} <span className="text-gray-500 text-xs">{l.start_date} – {l.end_date}</span>
        </button>
      ))}
      <WriteOnly>
      {list.length > 0 && <div className="my-1 border-t border-gray-200" />}
      <button type="button" role="menuitem" data-launch-new className={`${menuItem} text-accent font-medium`} onClick={onNew}>+ New launch</button>
      </WriteOnly>
      {active && <button type="button" role="menuitem" data-launch-edit className={menuItem} onClick={() => onEdit(active)}>Edit launch…</button>}
    </ToolbarDropdown>
  );
}
